/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, group: NonNullable<unknown> }} Assistant_Activity_SearchInputs */



/**
* | output |
* | --- |
* | "Found {count} matching events in {group}" |
*
* @param {Assistant_Activity_SearchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_search = /** @type {((inputs: Assistant_Activity_SearchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_SearchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Événements correspondants trouvés dans ${i?.count} : ${i?.group}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Es wurden übereinstimmende Ereignisse in ${i?.group} gefunden (${i?.count}).`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Trovati ${i?.count} eventi corrispondenti in ${i?.group}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Обнаружено ${i?.count}, соответствующее событиям в ${i?.group}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se encontraron eventos coincidentes de ${i?.count} en ${i?.group}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`在 ${i?.group} 中找到与 ${i?.count} 匹配的事件`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.group} 内のイベントに一致する ${i?.count} が見つかりました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.group} में ${i?.count} से मेल खाने वाली घटनाएँ मिलीं`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Foram encontrados ${i?.count} eventos correspondentes em ${i?.group}`)
	return /** @type {LocalizedString} */ (`Found ${i?.count} matching events in ${i?.group}`)
});